import React, { Fragment } from "react";

export default function FillInBlanks({ answer }) {
  return (
    <div className="mb-2">
      <div className="answer_box mt-2">
        <p className="d-flex flex-wrap gap-1 align-items-center">
          {answer?.question?.bankQuestion?.map((word, i) => (
            <Fragment key={i}>
              {answer?.studentSelectedBanks?.some((b) => b.indexNo === i) ? (
                <span className="border-purple rounded-1 px-2 py-1">
                  {
                    answer?.studentSelectedBanks?.find((b) => b.indexNo === i)
                      ?.answers?.[0]
                  }
                </span>
              ) : (
                <span>{word + " "}</span>
              )}
            </Fragment>
          ))}
        </p>
      </div>
      <h4 className="v_more cursor my-2">Word bank</h4>
      <div className="d-flex flex-wrap align-items-center">
        {answer?.question?.blanksBank?.map((word, i) => (
          <div className="w-50" style={{ paddingRight: ".525rem" }}>
            <p
              className="border py-1 px-2 mt-2 mb-0 w-100"
              style={{ borderRadius: "2px" }}
            >
              {word?.answers?.join(",")}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
